export const cssBundleHref = "/build/css-bundle-3KMSRTUI.css";